/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Trans } from "react-i18next";
import { Tab, Nav } from "react-bootstrap";
import requireAuth from "components/hoc/requireAuth";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { api } from "api";
import EmployeeLeavings from "./EmployeeLeavings";
import NewGraduates from "./NewGraduates";

class ApplicantPoolContainer extends Component {
  state = {
    tab1DataFetched: false,
    tab2DataFetched: false,
    approvedApplicantPool: [],
    approvedApplicantPoolMTAL: [],
    currentTab: "#tab1",
  };

  componentDidMount() {
    this.fetchTab1Data();
  }

  fetchTab1Data = () => {
    this.props.onProcessBegin();
    api
      .get(`/api/applicant-pool/get-approved-applicant-pool`)
      .then((response) => {
        this.setState({
          tab1DataFetched: true,
          approvedApplicantPool: response.data.data.items,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.props.onProcessEnd();
        this.fetchTab2Data();
      });
  };

  fetchTab2Data = () => {
    this.props.onProcessBegin();
    api
      .get(`/api/applicant-pool/get-approved-applicant-pool-mtal`)
      .then((response) => {
        this.setState({
          tab2DataFetched: true,
          approvedApplicantPoolMTAL: response.data.data.items,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.props.onProcessEnd();
      });
  };

  renderTabbedContent = () => {
    if (!this.state.tab1DataFetched || !this.state.tab2DataFetched) {
      return null;
    }

    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <Tab.Container
          id="nav-tab"
          defaultActiveKey="#tab1"
          activeKey={this.state.currentTab}
        >
          <nav className="scrollNav">
            <Nav variant="tabs" role="tablist">
              <Nav.Item>
                <Nav.Link
                  onClick={() => this.setState({ currentTab: "#tab1" })}
                  eventKey="#tab1"
                >
                  <Trans desc="Ayrılan Çalışan">10599</Trans>
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link
                  onClick={() => this.setState({ currentTab: "#tab2" })}
                  eventKey="#tab2"
                >
                  <Trans desc="Yeni Mezun">10600</Trans>
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </nav>

          <Tab.Content>
            <Tab.Pane eventKey="#tab1">
              {this.state.tab1DataFetched && (
                <EmployeeLeavings
                  employees={this.state.approvedApplicantPool}
                />
              )}
            </Tab.Pane>
            <Tab.Pane eventKey="#tab2">
              {this.state.tab2DataFetched && (
                <NewGraduates
                  employees={this.state.approvedApplicantPoolMTAL}
                />
              )}
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    );
  };

  render() {
    return (
      <section className="profilArea my-3">
        {this.props.spinner}
        <div className="container">
          <div className="row d-none d-sm-none d-md-flex d-lg-flex py-4 topRow align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
              <ul className="fgaBreadcrumb">
                <li>
                  <a href="/" style={{ verticalAlign: "middle" }}>
                    <span className="iconmford fo-icon-home"></span>
                  </a>
                </li>
                <li>
                  <a href="#" style={{ verticalAlign: "middle" }}>
                    <Trans desc="Eğitim ve Gelişim">10025</Trans>
                  </a>
                </li>
                <li className="active">
                  <Trans desc="Aday Havuzu">10598</Trans>
                </li>
              </ul>
            </div>
          </div>
          <div className="row d-flex d-sm-flex d-md-none d-lg-none py-4 topRow">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
              <div className="profilBaslik">
                <Trans desc="Aday Havuzu">10598</Trans>
              </div>
            </div>
          </div>
          <div className="row py-4 bottomRow">{this.renderTabbedContent()}</div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(
  mapStateToProps,
  {}
)(requireAuth(containsLongRunningProcess(ApplicantPoolContainer)));
